import React from 'react';
import './Home.css';
import images from './images'; // Import the images object

const Home = () => {
  return (
    <div  id="home">
    <div className="home-container">
      <div className="left-side">



      <a href="https://www.facebook.com/prinsajoshi1/"><div class="facebook play-on"></div></a>

        <a  href="mailto:joshi.prinsa1234@gmail.com"><div class="mail play-on"></div></a>
        <a href="https://www.instagram.com/_prinsa.07/?next=%2F&hl=en"><div class="instagram play-on"></div></a>
        <a href="https://www.reddit.com/user/P-Prinsa007/"><div class="reddit play-on"></div></a>
        <a href="https://www.linkedin.com/in/prinsa-joshi/"><div class="linkedin play-on"></div></a>
        <a href="https://github.com/prinsajoshi"><div class="github play-on"></div></a>
        <a href="https://medium.com/@joshi-prinsa1234"><div class="medium play-on"></div></a>
        <a href="https://x.com/JoshiPrinsa"><div class="twitter play-on"></div></a>


        {/* Add more social media icons as needed */}

      </div>
      <div className="right-side">
        {/* Image */}
        <img src={images['my-profile.jpg']} alt="Profile" />

        {/* Text */}
        <div className="home_title">
        <h1 className="home_letter">
        <span className="text-animate-hover">H</span>
        <span className="text-animate-hover _12">i, </span> 
        <tab/> <tab/><tab/>
         <span className="text-animate-hover _13">I</span>
         <span className="text-animate-hover _14">'m</span><br/>
         <div className="logoP" ></div>
         <div className='rest-name'>
          <span className="text-animate-hover _15">r</span>
          <span className="text-animate-hover _16">i</span>
          <span className="text-animate-hover _17">n</span>
          <span className="text-animate-hover _18">s</span>
          <span className="text-animate-hover _19">a</span>
          <tab/> <tab/><tab/>
          
          <span className="text-animate-hover _20"> </span>
          <span className="text-animate-hover _21">J</span>
          <span className="text-animate-hover _22">o</span>
          <span className="text-animate-hover _23">s</span>
          <span className="text-animate-hover _24">h</span>
          <span className="text-animate-hover _25">i</span>
          </div>
          </h1>
          <h2 className='line-before' >Computer Engineering Student</h2>
          <button className='say-hello'></button>

          <br/>
          </div>
        {/* Button */}


      </div>
    </div>
    </div>
  );
};

export default Home;
